import Vue from 'vue';
import VueCodemirror from 'vue-codemirror'
import 'codemirror/addon/selection/active-line.js'
import 'codemirror/lib/codemirror.css'
import 'codemirror/lib/codemirror.js'
import 'codemirror/theme/monokai.css'
import 'codemirror/theme/idea.css'
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/hint/html-hint.js'
import 'codemirror/addon/hint/javascript-hint.js'
import 'codemirror/addon/hint/css-hint.js'
import 'codemirror/addon/lint/json-lint.js'
import 'codemirror/addon/display/fullscreen.css'
import 'codemirror/addon/comment/comment.js'
// 高亮行功能
import 'codemirror/addon/selection/active-line'
import 'codemirror/addon/selection/selection-pointer'
import 'codemirror/addon/hint/show-hint.js'
// 代码折叠
import 'codemirror/addon/fold/foldcode'
import 'codemirror/addon/fold/foldgutter'
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/brace-fold'
import 'codemirror/addon/fold/comment-fold'
import 'codemirror/addon/fold/xml-fold.js';
import 'codemirror/addon/fold/indent-fold.js';
import 'codemirror/addon/fold/markdown-fold.js';
import 'codemirror/addon/fold/comment-fold.js';
import 'codemirror/mode/python/python.js'
import 'codemirror/mode/clike/clike'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/css/css.js'
import 'codemirror/mode/htmlmixed/htmlmixed.js'
import 'codemirror/addon/edit/closebrackets.js'
import 'codemirror/addon/edit/matchbrackets.js'
import 'codemirror/keymap/sublime.js'
// 调整scrollbar样式功能
import 'codemirror/addon/scroll/simplescrollbars.css'
import 'codemirror/addon/scroll/simplescrollbars'

Vue.use(VueCodemirror, {
    options: {
      tabSize: 4, //tab宽度
      keyMap: "sublime", // 快键键风格
      styleActiveLine: true,  //行高亮
      lineNumbers: true,     // 编辑器左侧显示行号
      line: true,
      // theme: 'monokai',
      theme: 'idea',      // 主题
      // 在行槽中添加行号显示器、折叠器、语法检测器
      gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter", "CodeMirror-lint-markers"], 
      foldGutter: true, // 启用代码折叠
      autocorrect: true, //启用自动纠正
      lineWrapping: true,   // 软换行
      matchBrackets: true,  // 括号匹配
      autoCloseBrackets: true, //自动补全括号
      indentUnit: 4,
       scrollbarStyle: 'overlay',// scrollbar样式功能
       extraKeys: { 'Ctrl': 'autocomplete' }, //代码补全快捷键
    }
  })


// WEBPACK FOOTER //
// ./src/plugins/codemirror.js